import React from 'react'
import { observer, inject } from 'mobx-react'
import { StateType } from '../state/state'
import { Search } from '../../../components/ui/Search'
import { MAX_ACTIVE_COUNTRIES } from '../constants'
import { ShowXYLabelsToggle } from './ShowXYLabelsToggle'

interface Props {
  className?: string
  state?: StateType
}

export const CountryMultiSelect: React.FC<Props> = inject('state')(
  observer(({ className = '', state }) => {
    const {
      countryOptions,
      activeCountriesWithLabel,
      addActiveCountry,
      removeActiveCountry,
      updateDomainAfterFiltering,
      activeOrOveredCountries,
      resetXDomainMinOverride,
      resetXDomainMaxOverride,
      resetYDomainMinOverride,
      resetYDomainMaxOverride,
    } = state.ScatterplotState

    return (
      <>
        <Search
          className={`pr1 ${className}`}
          options={countryOptions}
          defaultValue={activeCountriesWithLabel}
          onChange={(filteredCountries, action) => {
            if (action.action === 'select-option') {
              addActiveCountry(action.option.value)
              updateDomainAfterFiltering()
            }
            if (action.action === 'remove-value') {
              removeActiveCountry(action.removedValue.value)
              if (activeOrOveredCountries.length === 0) {
                resetXDomainMinOverride()
                resetXDomainMaxOverride()
                resetYDomainMinOverride()
                resetYDomainMaxOverride()
              }
            }
          }}
          placeholder={activeCountriesWithLabel.length === 0 ? 'Search up to 5 countries' : 'Search more'}
          searchableLimit={MAX_ACTIVE_COUNTRIES}
          isMulti
        />

        <ShowXYLabelsToggle className="mt3" />
      </>
    )
  })
)
